import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import HorizontalStack from 'Components/ComponentLibrary/Atoms/Layout/HorizontalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import WhatIfClientScenarioDetails from 'Components/ComponentLibrary/Organisms/WhatIfClientScenarioDetails';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import CommentsHeader from 'Views/Page/Content/Templates/WhatIfClientTemplate/Components/CommentsHeader';
import HeaderBar from 'Components/ComponentLibrary/Molecules/HeaderBar';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import SelectScenarioButtonPicker
  from 'Views/Page/Content/Templates/WhatIfClientTemplate/Content/SelectScenarioButtonPicker';
import HamburgerMenuWithSiteNavigation from 'Components/ComponentLibrary/Molecules/HamburgerMenuWithSiteNavigation';
import BackButtonPicker from './BackButtonPicker';
import { useCommentLayoutContext } from '../CommentLayoutProvider';
import Comments from './Comments';
import RightColumnPicker from './RightColumnPicker';
import FooterPicker from './FooterPicker';

const Content = () => {
  const isMobile = useMobileLayout();
  const { pageContentCollection, pageContentResource } = usePageContentContext();
  const { showCommentLayout } = useCommentLayoutContext();
  const header = pickFunction(pageContentResource, {
    [fr.relationships.activationConfirmation.name]: () => {
      return (
        <HeaderBar
          title="Scenario Selection"
          color="black"
          left={<BackButtonPicker />}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      return (
        <HeaderBar
          title="My Scenario"
          color="black"
          left={isMobile
            ? (
              <HamburgerMenuWithSiteNavigation
                color="black"
              />)
            : null
        }
          transparentBackground
        />
      );
    },
  });

  const showingMobileComments = isMobile && showCommentLayout;

  return (
    <HorizontalStack>
      <VerticalStack height={'screen'}>
        <StackItem hidden={!showingMobileComments} position={'top'}>
          <CommentsHeader />
        </StackItem>
        <StackItem scrollable fillsSpace hidden={showingMobileComments}>
          <WhatIfClientScenarioDetails
            facetPlanClientViewCollection={pageContentCollection}
            facetPlanClientViewResource={pageContentResource}
            header={header}
            callToAction={<SelectScenarioButtonPicker />}
          />
        </StackItem>
        <StackItem fillsSpace hidden={!showingMobileComments} />
        <StackItem scrollable hidden={!showingMobileComments}>
          <Comments />
        </StackItem>
        <StackItem fullWidth position={'bottom'}>
          <FooterPicker />
        </StackItem>
      </VerticalStack>
      <StackItem hidden={isMobile} unshrinkable>
        <RightColumnPicker />
      </StackItem>
    </HorizontalStack>
  );
};

export default Content;
